var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_wrap"},[_c('div',{staticClass:"page_width"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('common.internetContentProvider')))]),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.$t('common.copyright')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }